import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardHeader,
  Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next"; // Functional Components
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import palette from "../../styles/theme/palette";
import { ReportApi } from "../../api/ReportApi";
import ChartSkeleton from "./ChartSkeleton";

ChartJS.register(
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  Title
);

export default function YearReport({ type }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState();
  const [options, setOptions] = useState();
  const [labels, setLabels] = useState();
  const [value, setValue] = useState();

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    initChart();
  }, [data, type]);

  const fetchData = async () => {
    setIsLoading(true);
    const response = await ReportApi.getYearReport();
    setData(response);
    setIsLoading(false);
  };

  const initChart = () => {
    if (!data) return;

    const response = data;

    setOptions({
      responsive: true,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: `${response.dateRange.map((item) => item).join(" ~ ")}`,
        },
      },
    });

    let labelList = response.result.map((item) => item.year);

    setLabels(labelList);

    setValue({
      labels: labelList,
      datasets: [
        {
          label:
            type == "amount"
              ? `${t("dashboard.order_total")}`
              : `${t("dashboard.order_count")}`,
          data:
            type == "amount"
              ? response.result.map((item) => item.orderAmount)
              : response.result.map((item) => item.orderCount),
          borderColor: palette.primary.main,
          backgroundColor: palette.primary.dark,
          borderWidth: 2,
          fill: false,
        },
      ],
    });
  };

  if (isLoading) {
    return <ChartSkeleton />;
  }

  return (
    <Card variant="outlined">
      <CardHeader title={t("dashboard.yearly")} sx={{ textAlign: "center" }} />
      <Divider />
      <Box sx={{ p: 2 }}>
        {options && value && (
          <Bar
            style={{ maxHeight: 300, maxWidth: "100%" }}
            options={options}
            data={value}
          />
        )}
      </Box>
    </Card>
  );
}
